import React from 'react'
import AlertModal from '@/components/modals/AlertModal'
import { BaseModalProps } from '@/components/modals/base-modal/base-modal'
import { NavigateFunction, useNavigate } from 'react-router-dom'

interface Props extends BaseModalProps {}

const DealAlreadyExistsForProposalModal: React.FC<Props> = ({ ...props }) => {
  const navigate: NavigateFunction = useNavigate()
  const onCancel = () => {
    navigate('/')
  }
  return (
    <AlertModal
      onSubmit={props.onClose}
      onCancel={onCancel}
      cancelText={'ביטול'}
      {...props}
    >
      זוהתה עסקה משוייכת להצעת מחיר זו, האם ברצונך להמשיך?
    </AlertModal>
  )
}

export default DealAlreadyExistsForProposalModal
